import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last updated:</strong> October 11, 2024
      </p>

      <p>
        <strong>MuseMatch</strong> ("we", "our", or "us") is committed to
        protecting your privacy. This Privacy Policy explains how your personal
        information is collected, used, and disclosed by MuseMatch when you
        access or use our Service.
      </p>

      <p>
        By using our Service, you agree to the collection and use of information
        in accordance with this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        When you use our Service, we may collect the following types of
        information:
      </p>
      <h3>a) Personal Information</h3>
      <ul>
        <li>
          <strong>Name</strong>: To identify users.
        </li>
        <li>
          <strong>Email address</strong>: To communicate with users.
        </li>
        <li>
          <strong>Payment Information</strong>: Payment details may be processed
          through third-party payment providers like Stripe.
        </li>
        <li>
          <strong>Shipping Information</strong>: If you're selling or purchasing
          artwork through the platform.
        </li>
      </ul>

      <h3>b) Non-Personal Information</h3>
      <ul>
        <li>
          <strong>Log Data</strong>: We may collect information about your
          device, browser, and access times when you use our website.
        </li>
        <li>
          <strong>Cookies</strong>: Small data files stored on your device to
          improve the user experience. You may refuse cookies via your browser
          settings.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We may use the information we collect for the following purposes:</p>
      <ul>
        <li>To provide and maintain the Service.</li>
        <li>To facilitate transactions and process payments.</li>
        <li>
          To communicate with you regarding your account, orders, or technical
          support.
        </li>
        <li>To improve the Service by understanding user behavior.</li>
        <li>
          To ensure legal compliance, including enforcing our terms and
          protecting our users.
        </li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>
        We do not share your personal information with third parties except in
        the following situations:
      </p>
      <ul>
        <li>
          <strong>Payment Providers</strong>: When you make payments, your
          details are shared with payment providers like Stripe for payment
          processing.
        </li>
        <li>
          <strong>Service Providers</strong>: We may employ third-party
          companies to assist in providing the Service.
        </li>
        <li>
          <strong>Legal Obligations</strong>: We may disclose information if
          required by law or in response to valid legal requests.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable measures to protect your personal information, but
        please note that no method of transmission over the Internet or
        electronic storage is 100% secure. While we strive to use commercially
        acceptable means to protect your data, we cannot guarantee its absolute
        security.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal
        information. You can manage your data directly through your account
        settings or contact us for assistance.
      </p>

      <h2>6. Links to Other Sites</h2>
      <p>
        Our Service may contain links to third-party websites. We are not
        responsible for the content or privacy practices of these websites. We
        recommend reviewing the privacy policies of any third-party sites you
        visit.
      </p>

      <h2>7. Children's Privacy</h2>
      <p>
        Our Service does not address individuals under the age of 13. We do not
        knowingly collect personally identifiable information from anyone under
        the age of 13. If we discover that a child under 13 has provided us with
        personal information, we will delete such information.
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated "Last updated" date. We encourage
        you to review this Privacy Policy periodically.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        at:
      </p>
      <p>
        <strong>Email</strong>: contact@musematch.com <br />
      </p>
    </div>
  );
};

export default PrivacyPolicy;
